import { isNil } from 'lodash';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBTextBody2 } from '@shared/components/typography';
import { Colors, grid } from '@shared/styles';
import { ChatDateStamp } from '../../ChatDateStamp';
import { Styles } from '../styles';

interface MBSenderNameProps {
  name?: string;
  date: string;
  align: 'left' | 'right';

  /*
        If set, a placeholder the same width as a message bubble user image
        will be placed next to the sender name.
    */
  imagePlaceholder: boolean;
}

export function MBSenderName({ name, date, align, imagePlaceholder }: MBSenderNameProps) {
  const alignStyle = align === 'left' ? Styles.rowAlignLeft : Styles.rowAlignRight;

  return (
    <MBView paddingTop={1.25} paddingBottom={0.5} paddingHorizontal={1.75} style={[alignStyle]}>
      {imagePlaceholder && <MBView style={Styles.userImagePlaceholder} />}
      <View row style={{ alignItems: 'baseline' }}>
        {!isNil(name) && (
          <MBTextBody2 color={Colors.v2.gray50} style={{ marginRight: grid(1.5) }}>
            {name}
          </MBTextBody2>
        )}
        <ChatDateStamp date={date} />
      </View>
    </MBView>
  );
}
